/**
 * CSV Export Utilities for Port Management
 */

/**
 * Export ports to CSV
 */
export const exportPortsToCSV = (ports, renderGatewayName) => {
  const headers = [
    'gateway',
    'number_source',
    'port_number',
    'assigned_number',
    'mobile_operator',
    'is_sim_converted',
    'sim_conversion_requested',
    'sim_converted_note',
    'user_code',
    'user_email',
    'slack_user_id',
    'credit_balance',
    'last_message_sent',
    'description',
    'created_at',
    'assigned'
  ];

  const lines = [headers.join(',')];

  ports.forEach((p) => {
    const row = {
      gateway: renderGatewayName(p),
      number_source: p.number_source === 'service' || p.is_sim_converted === 2 ? 'service' : 'gateway',
      port_number: p.port_number || '',
      assigned_number: p.assigned_number || '',
      mobile_operator: p.mobile_operator || '',
      is_sim_converted:
        p.is_sim_converted === 2 ? 'Yes' : p.is_sim_converted === 1 ? 'No' : '',
      sim_conversion_requested:
        p.req_sim_conversion === true ||
        p.req_sim_conversion === 1 ||
        p.req_sim_conversion === '1'
          ? p.req_sim_conversion_id
            ? `Yes #${p.req_sim_conversion_id}`
            : 'Yes'
          : 'No',
      sim_converted_note: p.sim_converted_note || '',
      user_code: p.user_code || '',
      user_email: p.user_email || '',
      slack_user_id: p.slack_user_id || '',
      credit_balance:
        p.credit_balance === null ||
        p.credit_balance === undefined ||
        p.credit_balance === ''
          ? ''
          : p.credit_balance,
      last_message_sent: p.last_message_sent || '',
      description: p.description || '',
      created_at: p.created_at || '',
      assigned: p.assigned ? 'Yes' : 'No'
    };

    const line = headers
      .map((h) => {
        const val = String(row[h] ?? '').replace(/"/g, '""');
        return `"${val}"`;
      })
      .join(',');

    lines.push(line);
  });

  const blob = new Blob([lines.join('\n')], {
    type: 'text/csv;charset=utf-8;',
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'ports_export.csv';
  link.click();
  URL.revokeObjectURL(url);
};


